import React from 'react';
import ClassSelectPage from './ClassSelectPage';

const SeatSelectPage = () => {
  return <ClassSelectPage type="seat" />;
};

export default SeatSelectPage;







